import { useLang, scrollToId } from "@/i18n";
import { Link } from "react-router-dom";
import { LogoMark } from "./Nav";
import { Mail, Globe } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="page-footer" className="border-t border-white/10 bg-[#030712] py-10">
      <div className="mx-auto flex max-w-7xl flex-col md:flex-row items-center justify-between gap-6 px-4 sm:px-6 lg:px-10">
        <button onClick={() => scrollToId("top")} className="flex items-center gap-3 min-h-12" data-testid="footer-logo-button">
          <LogoMark size={32} />
          <span className="font-display text-sm font-bold tracking-tight">
            Studio <span className="text-vortex-gradient">vortex 360</span>
          </span>
        </button>
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
          <a
            data-testid="footer-email-link"
            href="mailto:vortex360studio@gmail.com"
            className="inline-flex items-center gap-2 min-h-12 px-4 rounded-full text-sm text-slate-300 border border-white/10 hover:border-cyan-400/50 hover:text-cyan-300 transition-colors duration-300"
          >
            <Mail className="w-4 h-4 text-cyan-400" />
            vortex360studio@gmail.com
          </a>
          <a
            data-testid="footer-website-link"
            href="https://studiovortex360.hu"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 min-h-12 px-4 rounded-full text-sm text-slate-300 border border-white/10 hover:border-cyan-400/50 hover:text-cyan-300 transition-colors duration-300"
          >
            <Globe className="w-4 h-4 text-cyan-400" />
            studiovortex360.hu
          </a>
        </div>
        <div className="flex flex-col items-center md:items-end gap-1">
          <div className="flex items-center gap-5">
            <Link
              to="/adatkezeles"
              data-testid="footer-privacy-link"
              className="inline-flex items-center min-h-12 text-sm text-slate-400 hover:text-cyan-300 transition-colors duration-300 underline-offset-4 hover:underline"
            >
              {t.footer.privacy}
            </Link>
            <Link
              to="/aszf"
              data-testid="footer-terms-link"
              className="inline-flex items-center min-h-12 text-sm text-slate-400 hover:text-cyan-300 transition-colors duration-300 underline-offset-4 hover:underline"
            >
              {t.footer.terms}
            </Link>
          </div>
          <p className="text-sm text-slate-500">© {new Date().getFullYear()} Studio vortex 360. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
